import { Button } from "./ui/button";
import { Home, Bot, Users, Phone, BookOpen, ShoppingCart, Sparkles, UserSquare2 } from "lucide-react";
import { NavLink } from "./NavLink";
import TrustRibbon from "./TrustRibbon";
import neilLogo from "@/assets/neil-ai-logo.jpeg";
import puduLogo from "@/assets/pudu-logo-official.png";
import { Link } from "react-router-dom";

const Navigation = () => {
  const navLinks = [
    { to: "/", icon: Home, label: "Home" },
    { to: "/robots", icon: Bot, label: "Robots" },
    { to: "/ai-automation", icon: Sparkles, label: "AI Automation" },
    { to: "/case-studies", icon: Users, label: "Case Studies" },
    { to: "/accessories", icon: ShoppingCart, label: "Accessories" },
    { to: "/blog", icon: BookOpen, label: "Blog" },
    { to: "/about", icon: Users, label: "About" },
    { to: "/#team", icon: UserSquare2, label: "Team" },
    { to: "tel:3369624539", icon: Phone, label: "Contact" },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <TrustRibbon />

      <nav
        aria-label="Primary"
        className="border-b border-[hsl(var(--line))] backdrop-blur-xl bg-background/85"
      >
        <div className="max-w-7xl mx-auto px-3 md:px-5 h-14 md:h-16 flex items-center justify-between gap-3">
          <Link to="/" aria-label="Neil AI Global Solutions home" className="flex items-center gap-2 sm:gap-3 min-w-0 group">
            <img
              src={neilLogo}
              alt="Neil AI Global Solutions"
              className="h-7 md:h-8 w-auto rounded object-cover ring-1 ring-[hsl(var(--line))]"
            />
            <div className="hidden sm:block min-w-0 leading-none">
              <p className="text-[11px] md:text-[12px] font-bold tracking-[0.18em] text-foreground">
                NEIL AI <span className="text-primary">GLOBAL</span>
              </p>
              <p className="text-[8px] md:text-[9px] tracking-[0.32em] text-muted-foreground mt-1">
                AUTOMATE · ELEVATE · DOMINATE
              </p>
            </div>
            <div className="h-6 md:h-8 w-px bg-[hsl(var(--line))] mx-0.5 md:mx-1" />
            <div className="flex items-center gap-1.5 md:gap-2">
              <img
                src={puduLogo}
                alt="PUDU Robotics"
                className="h-5 md:h-6 w-auto object-contain"
              />
              <span className="hidden md:inline text-[9px] tracking-[0.18em] uppercase text-muted-foreground font-semibold leading-tight">
                Authorized<br/>Dealer
              </span>
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-0.5 lg:gap-1">
            {navLinks.map((link) => {
              const Icon = link.icon;
              return (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className="flex items-center gap-1.5 px-2.5 lg:px-3 h-9 rounded-full text-[12px] font-medium text-muted-foreground hover:text-foreground hover:bg-primary/5 transition-colors"
                  activeClassName="text-primary bg-primary/10"
                >
                  <Icon className="h-3.5 w-3.5" />
                  <span className="hidden lg:inline">{link.label}</span>
                </NavLink>
              );
            })}
          </div>

          <Button
            asChild
            size="sm"
            className="shrink-0 h-9 px-4 text-[12px] font-semibold tracking-wide rounded-full bg-gradient-to-r from-[hsl(43_75%_55%)] to-[hsl(43_85%_65%)] text-black hover:opacity-95 shadow-[0_4px_20px_hsl(43_75%_55%/0.35)]"
          >
            <a
              href="https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics"
              target="_blank"
              rel="noopener noreferrer"
            >
              Book Demo
            </a>
          </Button>
        </div>

        {/* Mobile nav row */}
        <div className="md:hidden border-t border-[hsl(var(--line))] px-2 py-1.5 flex items-center gap-1 overflow-x-auto no-scrollbar">
          {navLinks.map((link) => {
            const Icon = link.icon;
            return (
              <NavLink
                key={link.to}
                to={link.to}
                className="flex items-center justify-center h-8 w-8 rounded-full text-muted-foreground hover:text-foreground hover:bg-primary/5 shrink-0"
                activeClassName="text-primary bg-primary/10"
              >
                <Icon className="h-3.5 w-3.5" />
              </NavLink>
            );
          })}
        </div>
      </nav>
    </header>
  );
};

export default Navigation;
